const LOCALE = "en-IN";
const OPTIONS = { day: "numeric", month: "short", year: "numeric" };

function toDisplayDate(d) {
  return d.toLocaleDateString(LOCALE, OPTIONS);
}

/** Parse YYYY-MM-DD (optional time suffix) using local calendar day. */
function dateFromYmd(ymd) {
  if (ymd == null) return null;
  const part = String(ymd).split("T")[0].trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(part)) return null;
  const [y, m, d] = part.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

/**
 * Formats cart/order booking_date for display.
 * Supports JSON range {"start":"YYYY-MM-DD","end":"YYYY-MM-DD"}, same as object, or legacy single date string.
 * @param {string|object|null|undefined} raw
 * @returns {string} Empty string if nothing to show.
 */
export function formatBookingDateForDisplay(raw) {
  if (raw == null || raw === "") return "";

  let parsed = raw;
  if (typeof raw === "string") {
    const t = raw.trim();
    if (t.startsWith("{")) {
      try {
        parsed = JSON.parse(t);
      } catch {
        const single = dateFromYmd(t) || (t ? new Date(t) : null);
        return single && !Number.isNaN(single.getTime()) ? toDisplayDate(single) : "";
      }
    }
  }

  if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
    const start = parsed.start ?? parsed.startDate;
    const end = parsed.end ?? parsed.endDate;
    if (start && end) {
      const ds = dateFromYmd(start);
      const de = dateFromYmd(end);
      if (ds && de) {
        const sDay = String(start).split("T")[0];
        const eDay = String(end).split("T")[0];
        if (sDay === eDay) return toDisplayDate(ds);
        return `${toDisplayDate(ds)} – ${toDisplayDate(de)}`;
      }
    }
    if (start && !end) {
      const ds = dateFromYmd(start);
      return ds ? toDisplayDate(ds) : "";
    }
  }

  if (typeof raw === "string") {
    const t = raw.trim();
    const single = dateFromYmd(t) || (t ? new Date(t) : null);
    return single && !Number.isNaN(single.getTime()) ? toDisplayDate(single) : "";
  }

  return "";
}
